import { useState, useEffect } from 'react';
import { CheckCircle, Warning, ShieldCheck, ArrowRight } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Reset2FAPage() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (!t) setError('Geen geldige reset-link — token ontbreekt');
    setToken(t || '');
  }, []);

  const submit = async () => {
    setError(''); setLoading(true);
    try {
      const r = await fetch(`${API}/api/auth/reset-2fa`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });
      if (!r.ok) {
        const d = await r.json().catch(() => ({}));
        throw new Error(d.detail || 'Reset mislukt');
      }
      setDone(true);
      setTimeout(() => { window.location.href = '/login'; }, 3500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white border border-zinc-200 rounded-sm p-8" data-testid="reset-2fa-page">
        <h1 className="font-heading text-2xl font-black tracking-tight mb-1">Authenticator resetten</h1>
        <p className="text-sm text-zinc-500 mb-6">
          Bevestig om je 2FA te wissen. Bij de volgende login krijg je een nieuwe QR-code.
        </p>

        {done ? (
          <div className="space-y-4 text-center" data-testid="reset-2fa-success">
            <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
              <CheckCircle size={28} className="text-emerald-600" weight="fill" />
            </div>
            <div className="text-sm text-zinc-700">
              2FA is gereset. Login nu met je wachtwoord — je krijgt een nieuwe QR-code om je authenticator opnieuw te koppelen.
              <div className="mt-2 text-xs text-zinc-500">Je wordt doorgestuurd...</div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <div className="flex items-start gap-2 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-sm p-3">
              <ShieldCheck size={16} className="flex-shrink-0 mt-0.5" weight="fill" />
              <span>Door op de knop te klikken wordt je huidige authenticator ontkoppeld. Je hebt direct daarna toegang tot een nieuwe QR-code via de loginpagina.</span>
            </div>
            {error && (
              <div className="flex items-start gap-2 text-xs text-red-600 bg-red-50 border border-red-200 rounded-sm p-2">
                <Warning size={14} className="flex-shrink-0 mt-0.5" weight="fill" />
                <span>{error}</span>
              </div>
            )}
            <button
              onClick={submit} disabled={loading || !token}
              className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-[#0F172A] text-white text-sm font-medium rounded-sm hover:bg-[#1E293B] disabled:opacity-50"
              data-testid="reset-2fa-confirm-btn"
            >
              {loading ? 'Bezig...' : 'Authenticator resetten'}
              <ArrowRight size={14} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
